import { useLocation } from 'wouter';
import { trpc } from '../../lib/trpc';
import { useAsync } from '../../lib/useAsync';
import { Loading, ErrorBox, EmptyBox, KpiCard, StatusPill, PageTitle } from '../../components/admin/ui';
import {
  formatInt,
  TICKET_STATUS_LABEL,
  TICKET_STATUS_COLOR,
  PRIORIDADE_LABEL,
  PRIORIDADE_COLOR,
  CANAL_LABEL,
} from '../../lib/format';

export function AdminSuporte() {
  const [, navigate] = useLocation();
  const { data, loading, error, reload } = useAsync(() => trpc.admin.tickets.query());

  return (
    <div className="mx-auto max-w-5xl">
      <PageTitle titulo="Suporte com IA" />

      {loading && <Loading />}
      {error && <ErrorBox msg={error} onRetry={reload} />}

      {data && data.tickets.length === 0 && (
        <EmptyBox titulo="Sem tickets" descricao="Rode o seed de demonstração." />
      )}

      {data && data.tickets.length > 0 && (
        <>
          <div className="mb-4 grid grid-cols-3 gap-4">
            <KpiCard label="Tickets abertos" valor={formatInt(data.resumo.abertos)} destaque />
            <KpiCard label="Tempo médio de resposta" valor={`${data.resumo.tempoMedioRespostaHoras}h`} sub="dado de demonstração" />
            <KpiCard label="Satisfação" valor={`${data.resumo.satisfacaoPct}%`} sub="dado de demonstração" />
          </div>

          <div className="card overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-surface-2 text-left text-[11px] uppercase tracking-wider text-ink-4">
                <tr>
                  <th className="px-5 py-3 font-medium">Assunto</th>
                  <th className="px-3 py-3 font-medium">Cliente</th>
                  <th className="px-3 py-3 font-medium">Prioridade</th>
                  <th className="px-3 py-3 font-medium">Canal</th>
                  <th className="px-3 py-3 font-medium">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-line">
                {data.tickets.map((t) => (
                  <tr key={t.id} className="cursor-pointer hover:bg-bg-warm" onClick={() => navigate(`/admin/suporte/${t.id}`)}>
                    <td className="px-5 py-3 font-medium text-ink">{t.assunto}</td>
                    <td className="px-3 py-3 text-ink-2">{t.cliente}</td>
                    <td className="px-3 py-3">
                      <span className="text-xs font-medium" style={{ color: PRIORIDADE_COLOR[t.prioridade] }}>
                        {PRIORIDADE_LABEL[t.prioridade]}
                      </span>
                    </td>
                    <td className="px-3 py-3 text-ink-3">{CANAL_LABEL[t.canal] ?? t.canal}</td>
                    <td className="px-3 py-3">
                      <StatusPill label={TICKET_STATUS_LABEL[t.status]!} color={TICKET_STATUS_COLOR[t.status]!} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
